import { IOption } from '@srm/ui/types/IOption';

export enum TransitionType {
    //Последующий
    Next,
    //Предыдущий
    Prev,
    //Параллельный
    Parallel,
}

const TransitionTypeOption: IOption[] = [
    {
        label: 'Последующий',
        value: TransitionType[TransitionType.Next],
    },
    {
        label: 'Предыдущий',
        value: TransitionType[TransitionType.Prev],
    },
    {
        label: 'Параллельный',
        value: TransitionType[TransitionType.Parallel],
    },
];

export default TransitionTypeOption;
